import { Routes, Route } from "react-router-dom";
import { LOGIN,LOGOUT,FORGOT_PASSWORD } from "../constants/routes";
import LoginScreen from "../screens/LoginScreen";
import LogoutScreen from "../screens/LogoutScreen";
import ForgotPasswordScreen from "../screens/ForgotPasswordScreen";

const AuthRouter = () => {
  return (
    <Routes>
      <Route path={'/'} element={<LoginScreen />} />
      <Route path={LOGIN} element={<LoginScreen />} />
      <Route path={LOGOUT} element={<LogoutScreen />} />
      <Route path={FORGOT_PASSWORD} element={<ForgotPasswordScreen />} />
    </Routes>
  );
};

export default AuthRouter;
